var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "column" }, [
    _c("h5", [
      _vm._v(
        "\n        " +
          _vm._s(_vm.quote.product) +
          " Personalised Finance Quotation\n        \n        "
      ),
      _vm.financeVideo
        ? _c("a", { attrs: { href: _vm.financeVideo, target: "_blank" } }, [
            _vm._v(
              "\n            Why choose " +
                _vm._s(_vm.quote.product) +
                "?\n        "
            ),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c(
      "table",
      _vm._l(_vm.financeExample, function (item) {
        return _c("tr", [
          _c("th", [_vm._v(_vm._s(item.label) + ":")]),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(item.value))]),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }